module.exports = __webpack_public_path__ + "img/411.0e49f3b.0e49f3b8.png";